import colorString from 'color-string';
import colorConvert from 'color-convert';
import { HSL } from 'color-convert/conversions';

export function getFontColor(color: string): string {
  const colorDescriptor = colorString.get(color);
  if (!colorDescriptor || colorDescriptor.model !== 'rgb') {
    return colorString.to.hex(255, 255, 255)!;
  }
  const hslBgColor = colorConvert.rgb.hsl(
    colorDescriptor.value[0],
    colorDescriptor.value[1],
    colorDescriptor.value[2],
  );
  //  H = Hbg L = Lbg-50 S = Sbg-50
  const hslFontColor: HSL = [
    hslBgColor[0],
    hslBgColor[1] === 0
      ? 0
      : hslBgColor[1] - 50 < 0
        ? hslBgColor[1] + 50
        : hslBgColor[1] - 50,
    hslBgColor[2] - 50 < 0 ? hslBgColor[2] + 50 : hslBgColor[2] - 50,
  ];
  const rgb = colorConvert.hsl.rgb(hslFontColor);
  if (rgb.some((x) => x < 0)) {
    return colorString.to.hex(255, 255, 255)!;
  }
  return colorString.to.hex(rgb[0], rgb[1], rgb[2])!;
}

export function getBGColor(color: string, isNightTheme?: boolean): string {
  if (isNightTheme) {
    return getDarkThemeBGColor(color);
  }
  return color;
}

export function getHexColorName(color: string): string {
  const colorDescriptor = colorString.get(color);
  if (!colorDescriptor || colorDescriptor.model !== 'rgb') {
    return 'error';
  }
  return colorString.to.hex(
    colorDescriptor.value[0],
    colorDescriptor.value[1],
    colorDescriptor.value[2],
  )!;
}

export function getHoverColor(color: string): string {
  const colorDescriptor = colorString.get(color);
  if (!colorDescriptor || colorDescriptor.model !== 'rgb') {
    return color;
  }
  const hslBgColor = colorConvert.rgb.hsl(
    colorDescriptor.value[0],
    colorDescriptor.value[1],
    colorDescriptor.value[2],
  );
  //  H = Hbg L = Lbg S = Sbg+2
  const hslFontConlor: HSL = [hslBgColor[0], hslBgColor[1], hslBgColor[2] + 2];
  const rgb = colorConvert.hsl.rgb(hslFontConlor);
  return colorString.to.rgb(rgb[0], rgb[1], rgb[2])!;
}

function getDarkThemeBGColor(color: string): string {
  const colorDescriptor = colorString.get(color);
  if (!colorDescriptor || colorDescriptor.model !== 'rgb') {
    return color;
  }
  const hslBgColor = colorConvert.rgb.hsl(
    colorDescriptor.value[0],
    colorDescriptor.value[1],
    colorDescriptor.value[2],
  );
  //  H = Hbg L = Lbg-50 S = Sbg-50
  const hslFontColor: HSL = [
    hslBgColor[0],
    hslBgColor[1] === 0 ? 0 : 110 - hslBgColor[1],
    120 - hslBgColor[2],
  ];
  const rgb = colorConvert.hsl.rgb(hslFontColor);
  if (rgb.some((x) => x < 0)) {
    return colorString.to.hex(255, 255, 255)!;
  }
  return colorString.to.hex(rgb[0], rgb[1], rgb[2])!;
}
